import { render, staticRenderFns } from "./password-remind-sent.vue?vue&type=template&id=4c59348f"
import script from "./password-remind-sent.vue?vue&type=script&lang=js"
export * from "./password-remind-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports